/**
 * アンカーリンクのスムーズスクロール
 *
 * @param {number} slippage オフセット
 * @param {number} time     アニメーション時間 ms
 */
import jump from "jump.js";

export default (slippage = 0, time = 500) => {
  const elements = document.querySelectorAll('a[href^="#"]');
  const elementsArray = Array.prototype.slice.call(elements, 0);
  elementsArray.forEach((ele) => {
    ele.addEventListener("click", (event) => {
      event.preventDefault();
      const tg = event.target;
      const href = tg.getAttribute("href");
      const target = href === "#" ? "html" : href;
      jump(target, {
        duration: time,
        offset: slippage,
      });
    });
  });
};
